import { EmailsThemeDto } from "@babackapp/private-api-client/types";

export enum ThemeRadiusComponent {
	BUTTON = "button",
	CARD = "card",
	PACKAGE_CONTENT_TABLE = "packageContentTable",
	PACKAGE_CONTENT_IMAGE = "packageContentImage",
  BANNER_IMAGE = "bannerImage",
}

export type ThemeRadiusLevel = NonNullable<Required<EmailsThemeDto>["radius"]>;

export type RadiusValue = string;

// Radius mapping configuration: theme level -> component -> CSS class
const RADIUS_MAP: Record<ThemeRadiusLevel, Record<ThemeRadiusComponent, RadiusValue>> = {
	none: {
		[ThemeRadiusComponent.BUTTON]: "rounded-none",
		[ThemeRadiusComponent.CARD]: "rounded-none",
		[ThemeRadiusComponent.PACKAGE_CONTENT_TABLE]: "rounded-none",
		[ThemeRadiusComponent.PACKAGE_CONTENT_IMAGE]: "rounded-none",
		[ThemeRadiusComponent.BANNER_IMAGE]: "rounded-none",
	},
	low: {
		[ThemeRadiusComponent.BUTTON]: "rounded-sm",
		[ThemeRadiusComponent.CARD]: "rounded-sm",
		[ThemeRadiusComponent.PACKAGE_CONTENT_TABLE]: "rounded-sm",
		[ThemeRadiusComponent.PACKAGE_CONTENT_IMAGE]: "rounded-xs",
    [ThemeRadiusComponent.BANNER_IMAGE]: "rounded-xs",
	},
	default: {
		[ThemeRadiusComponent.BUTTON]: "rounded-md",
		[ThemeRadiusComponent.CARD]: "rounded-lg",
		[ThemeRadiusComponent.PACKAGE_CONTENT_TABLE]: "rounded-md",
		[ThemeRadiusComponent.PACKAGE_CONTENT_IMAGE]: "rounded-sm",
    [ThemeRadiusComponent.BANNER_IMAGE]: "rounded-md",
	},
	high: {
		[ThemeRadiusComponent.BUTTON]: "rounded-xl",
		[ThemeRadiusComponent.CARD]: "rounded-xl",
		[ThemeRadiusComponent.PACKAGE_CONTENT_TABLE]: "rounded-xl",
		[ThemeRadiusComponent.PACKAGE_CONTENT_IMAGE]: "rounded-lg",
    [ThemeRadiusComponent.BANNER_IMAGE]: "rounded-xl",
	}
};

export type ComponentRadiusMap = Record<ThemeRadiusComponent, RadiusValue>;
export type StringThemeRadiusComponent = `${ThemeRadiusComponent}`;

/**
 * Get radius values for components based on theme level
 * @param theme - EmailsThemeDto object containing radius configuration
 * @param component - Optional specific component to get radius for (string or enum)
 * @returns Either a specific radius value or all radius values
 */
export function getThemeRadius(theme: EmailsThemeDto | null | undefined): ComponentRadiusMap;
export function getThemeRadius(theme: EmailsThemeDto | null | undefined, component: StringThemeRadiusComponent | string): RadiusValue;
export function getThemeRadius(theme: EmailsThemeDto | null | undefined, component?: StringThemeRadiusComponent | string): ComponentRadiusMap | RadiusValue {
	const radiusLevel: ThemeRadiusLevel = theme?.radius ?? "default";
	const componentRadiusMap = RADIUS_MAP[radiusLevel];

	if (component) {
		return componentRadiusMap[component as ThemeRadiusComponent];
	}

	return componentRadiusMap;
}
